import './style.scss';

const PageNavigation = (navigation) => {
    if (!navigation || !navigation.items) {
        return null;
    }

    return (
        <ul className="nav nav-pills page-navigation p-2">
            {navigation.items.map((item, index) => {
                return (
                    <li className="nav-item" key={index}>
                        <a className="nav-link" href={item.link}>{item.text}</a>
                    </li>
                );
            })}
        </ul>
    );
};

export default PageNavigation;